import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { DeleteOutlined } from "@ant-design/icons";
import Loader from "react-loader-spinner";
import moment from "moment";
import {
  DatePicker,
  Input,
  Tabs,
  Button,
  Form,
  Select,
  Tooltip,
  Table,
  Popconfirm,
  Checkbox,
  InputNumber,
  Spin,

} from "antd";
import { Row as Brow, Col as Bcol } from "reactstrap";
import { ReadCookie } from "../../../../utils/readCookie";
import notification from "../../../../utils/notification";
import Tables from "../../../../components/Table/Tables";
import SubTitles from "../../../../components/SubTitle/SubTitle";
import "../../../../screens/SaleOrder/salesOrder.css";
import numeral from "numeral";
import { addModaProduct, getAllModaProductDetail, updateModaProduct } from "../../../../redux/actions/modaProductForm.action";
const { Option } = Select;
const { TabPane } = Tabs;
const { Search } = Input;

export default function ModaProductForm({
  formData,
  val,
  token,
  formState,
  submit,
  saleOrderID,
  setDisable
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const submitButton = useRef(null);
  const focusInput = useRef(null);
  const [form] = Form.useForm();
  const {

    modaProduct
  } = useSelector((state) => state);


  const [loading, setLoading] = useState(false);


  const location = useLocation();
  const [lines, setLines] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    if (formState === "add") {
      form.setFieldsValue({
        category: null,
        shop_sku: null,
        title: null,
        designer: null,
        variant_group_code: null,
        vendor_color: null,
        main_image: null,
        description: null,
        tariff_code: null,
        item_number_identifier: null,
        color: null,
        season: null,
        country_of_origin: null,
        item_number_identifier_type: null,
        customer_delivery_notes: null,
        made_to_order: null,
        variant_style_code: null,
        detail_bullets: null,
        material: null,
        image_2: null,
        image_3: null,
        image_4: null,
        image_5: null,
        image_6: null,
        image_7: null,
        sizes_clothing: null,
        fit_information: null,

        sku: null,
        product_id: null,
        product_id_type: null,
        offer_description: null,
        internal_description: null,
        price: null,
        price_additional_info: null,
        quantity: null,
        min_quantity_alert: null,
        state: null,
        //  available_start_date: formData.available_start_date ?? null,
        //  available_end_date: formData.available_end_date ?? null,
        discount_price: null,
        //  discount_start_date: formData.discount_start_date ?? null,
        //  discount_end_date: formData.discount_end_date ?? null,
        update_delete: null,
        retail_price: null
      });
      setLines([]);
      // history.push("/moda-product/add");
    }
  }, [formState]);






  useEffect(() => {
    if (formData?.length) {
      form.setFieldsValue({
        item_id: formData[0].item_id ?? null,
        category: formData[0].category ?? null,
        shop_sku: formData[0].shop_sku ?? null,
        title: formData[0].title ?? null,
        designer: formData[0].designer ?? null,
        variant_group_code: formData[0].variant_group_code ?? null,
        vendor_color: formData[0].vendor_color ?? null,
        main_image: formData[0].main_image ?? null,
        description: formData[0].description ?? null,
        tariff_code: formData[0].tariff_code ?? null,
        // item_number_identifier: formData[0].item_number_identifier ?? null,
        color: formData[0].color ?? null,
        season: formData[0].season ?? null,
        country_of_origin: formData[0].country_of_origin ?? null,
        item_number_identifier_type: formData[0].item_number_identifier_type ?? null,
        customer_delivery_notes: formData[0].customer_delivery_notes ?? null,
        made_to_order: formData[0].made_to_order ?? null,
        variant_style_code: formData[0].variant_style_code ?? null,
        detail_bullets: formData[0].detail_bullets ?? null,
        material: formData[0].material ?? null,
        image_2: formData[0].image_2 ?? null,
        image_3: formData[0].image_3 ?? null,
        image_4: formData[0].image_4 ?? null,
        image_5: formData[0].image_5 ?? null,
        image_6: formData[0].image_6 ?? null,
        image_7: formData[0].image_7 ?? null,
        // sizes_clothing: formData[0].sizes_clothing ?? null,
        fit_information: formData[0].fit_information ?? null,

        // sku: formData[0].sku ?? null,
        // product_id: formData[0].product_id ?? null,
        product_id_type: formData[0].product_id_type ?? null,
        offer_description: formData[0].offer_description ?? null,
        internal_description: formData[0].internal_description ?? null,
        price: formData[0].price ?? null,
        price_additional_info: formData[0].price_additional_info ?? null,
        quantity: formData[0].quantity ?? null,
        min_quantity_alert: formData[0].min_quantity_alert ?? null,
        state: formData[0].state ?? null,
        available_start_date: formData[0].available_start_date ? moment(formData[0].available_start_date) : null,
        available_end_date: formData[0].available_end_date ? moment(formData[0].available_end_date) : null,
        discount_price: formData[0].discount_price ?? null,
        discount_start_date: formData[0].discount_start_date ? moment(formData[0].discount_start_date) : null,
        discount_end_date: formData[0].discount_end_date ? moment(formData[0].discount_end_date) : null,
        update_delete: formData[0].update_delete ?? null,
        retail_price: formData[0].retail_price ?? null
      });
      setLines(formData);
    }
  }, [formData]);


  useEffect(() => {
    if (val) {
      submitButton.current.click();
    }
  }, [val]);







  const onFinish = async (event) => {

    submit(false);
    await form.validateFields().then((values) => {
      setLoading(true);
      setDisable(true);
      let parent = values;
      let child = lines;
      if (formState === "add") {
        dispatch(addModaProduct(token, parent, child)).then((res) => {
          if (res.type === "MODA_PRODUCT_FORM_SUCCESS") {
            notification(
              "success",
              "Add Moda Product",
              res?.payload?.message
            );
            history.push(`/moda-product/edit/${res?.payload?.item_id}?edit=yes`);
            setLoading(false);
            setDisable(false);
          }
          if (res.type === "MODA_PRODUCT_FORM_ERROR") {
            notification(
              "error",
              "Some Thing Went Wrong",
              "Please Try Again"
            );
          }
        });
      } else if (formState === "edit") {
        let item_id = id;
        let parent = values;
        let child = lines;
        dispatch(updateModaProduct(token, parent, child, item_id)).then((res) => {
          if (res.type === "UPDATE_MODA_PRODUCT_FORM_SUCCESS") {
            notification(
              "success",
              "Update Moda Product",
              res?.payload?.message
            );
            setLoading(false);
            setDisable(false);
          }
          if (res.type === "UPDATE_MODA_PRODUCT_FORM_ERROR") {
            notification(
              "error",
              "Some Thing Went Wrong",
              "Please Try Again"
            );
          }
        });
      }

    });
  };

  const handleTab = (key) => {

  };





  const onFinishFailed = () => {
    let errors = form.getFieldsError().filter((item) => item.errors.length > 0);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: errors[0]?.errors[0],
    });
    setLoading(false);
    setDisable(false);
  };














  const modacolumns = [

    {
      title: "GTIN Code",
      dataIndex: "item_number_identifier",
    },
    {
      title: "Clothing Sizes",
      dataIndex: "sizes_clothing",
    },

    {
      title: "Offer SKU",
      dataIndex: "shop_sku",
    },
    {
      title: "Product ID",
      dataIndex: "product_id",
    },

  ];


  const shopSkuOnSearch = (value) => {
    let shop_sku = form.getFieldValue("shop_sku");
    dispatch(getAllModaProductDetail(token, shop_sku)).then((res) => {
      if (res.type === "GET_ALL_MODA_PRODUCT_DETAIL_FORM_SUCCESS") {
        let Obj = res.payload.data[0];
        setLines(res.payload.data);
        form.setFieldsValue({
          category: Obj.category ?? null,
          shop_sku: Obj.sku ?? null,
          title: Obj.title ?? null,
          designer: Obj.designer ?? null,
          variant_group_code: Obj.variant_group_code ?? null,
          vendor_color: Obj.vendor_color ?? null,
          main_image: Obj.main_image ?? null,
          description: Obj.description ?? null,
          tariff_code: Obj.tariff_code ?? null,
          item_number_identifier: Obj.item_number_identifier ?? null,
          color: Obj.color ?? null,
          season: Obj.season ?? null,
          country_of_origin: Obj.country_of_origin ?? null,
          item_number_identifier_type: Obj.item_number_identifier_type ?? null,
          customer_delivery_notes: Obj.customer_delivery_notes ?? null,
          made_to_order: Obj.made_to_order ?? null,
          variant_style_code: Obj.variant_style_code ?? null,
          detail_bullets: Obj.detail_bullets ?? null,
          material: Obj.material ?? null,
          image_2: Obj.image_2 ?? null,
          image_3: Obj.image_3 ?? null,
          image_4: Obj.image_4 ?? null,
          image_5: Obj.image_5 ?? null,
          image_6: Obj.image_6 ?? null,
          image_7: Obj.image_7 ?? null,
          sizes_clothing: Obj.sizes_clothing ?? null,
          fit_information: Obj.fit_information ?? null,

          sku: Obj.sku ?? null,
          product_id: Obj.product_id ?? null,
          product_id_type: Obj.product_id_type ?? null,
          offer_description: Obj.offer_description ?? null,
          internal_description: Obj.internal_description ?? null,
          price: Obj.price ?? null,
          price_additional_info: Obj.price_additional_info ?? null,
          quantity: Obj.quantity ?? null,
          min_quantity_alert: Obj.min_quantity_alert ?? null,
          state: Obj.state ?? null,
          available_start_date: Obj.available_start_date ?? null,
          available_end_date: Obj.available_end_date ?? null,
          discount_price: Obj.discount_price ?? null,
          discount_start_date: Obj.discount_start_date ?? null,
          discount_end_date: Obj.discount_end_date ?? null,
          update_delete: Obj.update_delete ?? null,
          retail_price: Obj.retail_price ?? null
        });
      }
    })
  }


  window.addEventListener('keydown', function (e) { if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) { if (e.target.nodeName == 'INPUT' && e.target.type == 'text') { e.preventDefault(); return false; } } }, true);






  return (
    <>

      <Form
        requiredMark={false}
        autoComplete="off"
        onFinish={onFinish}
        form={form}
        onFinishFailed={onFinishFailed}
        name="basic"
      >
        {false ||
          (loading && (
            <div className="loaderDiv">
              <Loader type="Grid" color="#212121" height={40} width={40} />
            </div>
          ))}
        <div className="saleOrderForm">
          <SubTitles name={"Primary Information"} />
          <div className="primaryInfo container-fluid pbpx-0 ptpx-10">



            <Brow>
              <Bcol md={12} xl={12} xxl={12} className="pbpx-10">

                {/* ========== ROW 1 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="category" label="Category" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}>
                    <div className="firstSectionRo"><Form.Item name="shop_sku" label="Shop SKU" labelAlign="left" labelCol={{ span: 8 }}>
                      <Search className="customInputs" onSearch={shopSkuOnSearch}
                        enterButton={<Button disabled={formState !== "add" ? true : false}>Search</Button>}
                      /></Form.Item>
                      {/* <Button>Search</Button> */}
                    </div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="title" label="Product Name" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 2 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="designer" label="Designer Name" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="variant_group_code" label="Vendor Style No" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="vendor_color" label="Vendor Color" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 3 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="main_image" label="Main Image" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="description" label="Product Copy" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="tariff_code" label="Tariff Code" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 4 ========== */}
                <Brow>
                  {/* <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="item_number_identifier" label="GTIN Code" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol> */}
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="color" label="Moda Color" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="season" label="Season" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="country_of_origin" label="Origin Country" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 5 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="item_number_identifier_type" label="GTIN Type" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="customer_delivery_notes" label="Lead Time if Made-to-Order" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="made_to_order" label="Made To Order" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 6 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="variant_style_code" label="Vendor Style No (Repeated)" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="detail_bullets" label="Details" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="material" label="Material" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 7 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_2" label="on Model-Full Body" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_3" label="on Model-Crop Front" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_4" label="on Model-Crop Back" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 8 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_5" label="Ghost Back Images" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_6" label="Detail" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="image_7" label="Extra" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 9 ========== */}
                <Brow>
                  {/* <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="sizes_clothing" label="ClothingSizes" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol> */}
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="fit_information" label="Fit Information" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="product_id_type" label="Product ID Type" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="offer_description" label="Offer Description" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>



                {/* ========== ROW 11 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="internal_description" label="Offer Internal Description" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="price" label="Offer Price" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="price_additional_info" label="Offer Price Additional Info" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 12 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="quantity" label="Offer Quantity" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="min_quantity_alert" label="Minimum Quantity Alert" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="state" label="Offer State" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 13 ========== */}
                <Brow>

                  <Bcol lg={4}><div className="firstSectionRo">
                    <Form.Item name="available_start_date" label="Availability Start Date" labelAlign="left" labelCol={{ span: 8 }}
                    >
                      <DatePicker
                        size="small"
                        format="MM-DD-YYYY"
                        allowClear
                        className="dateInput customInputs"
                      />
                    </Form.Item>

                  </div></Bcol>

                  <Bcol lg={4}><div className="firstSectionRo">
                    <Form.Item name="available_end_date" label="Availability End Date" labelAlign="left" labelCol={{ span: 8 }}

                    >
                      <DatePicker
                        size="small"
                        format="MM-DD-YYYY"
                        allowClear
                        className="dateInput customInputs"
                      />
                    </Form.Item>
                  </div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="discount_price" label="Discount Price" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 14 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="discount_start_date" label="Discount Start Date" labelAlign="left" labelCol={{ span: 8 }}

                  >
                    <DatePicker
                      size="small"
                      format="MM-DD-YYYY"
                      allowClear
                      className="dateInput customInputs"
                    /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="discount_end_date" label="Discount End Date" labelAlign="left" labelCol={{ span: 8 }}

                  >
                    <DatePicker
                      size="small"
                      format="MM-DD-YYYY"
                      allowClear
                      className="dateInput customInputs"
                    /></Form.Item></div></Bcol>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="update_delete" label="Update/Delete" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

                {/* ========== ROW 15 ========== */}
                <Brow>
                  <Bcol lg={4}><div className="firstSectionRo"><Form.Item name="retail_price" label="Retail Price (In Store Currency)" labelAlign="left" labelCol={{ span: 8 }}><Input className="customInputs" /></Form.Item></div></Bcol>
                </Brow>

              </Bcol>
            </Brow>
            <Button
              htmlType="submit"
              style={{ display: "none" }}
              ref={submitButton}
              onClick={onFinish}
            />

          </div>

          <Tabs
            type="card"
            size="small"
            defaultActiveKey="1"
            centered
            onChange={(key) => handleTab(key)}
          >

            <TabPane tab="Moda Information" key="paymentInfo">

              {lines.length > 0 && (
                <Table

                  type={"company"}
                  // loading={modaProduct.loading}
                  scroll={({ x: 600 }, { y: 400 })}
                  size="small"
                  pagination={{ pageSize: 100 }}
                  bordered
                  dataSource={formState === "formView" || formState === "edit" ? lines && lines.filter(item => item.parent_item_id) : lines}
                  columns={modacolumns}

                />
              )}
            </TabPane>


          </Tabs>
        </div>
      </Form>
    </>
  );
}
